import { defineMessages } from 'react-intl';

export default defineMessages({
    policyDetails: {
        id: 'gw-portals-policytransaction-pc-bop-angular.policyDetails.policyDetails.Policy Details',
        defaultMessage: 'Policy Details'
    },
    policyDetailsDescription: {
        id: 'gw-portals-policytransaction-pc-bop-angular.policyDetails.policyDetails.Policy Change Description',
        defaultMessage: 'Policy Change Description'
    },
    policyChangeEffectiveDate: {
        id: 'gw-portals-policytransaction-pc-bop-angular.policyDetails.policyDetails.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date'
    },
    organizationType: {
        id: 'gw-portals-policytransaction-pc-bop-angular.policyDetails.policyDetails.Organization Type',
        defaultMessage: 'Organization Type'
    },
    smallBusinessType: {
        id: 'gw-portals-policytransaction-pc-bop-angular.policyDetails.policyDetails.Small Business Type',
        defaultMessage: 'Small Business Type'
    },
    cancelledInsuranceCompany: {
        id: 'quoteandbind.ho.policy-info.Have you been cancelled by an insurance company in the last 3 years',
        defaultMessage: 'Have you been cancelled by an insurance company in the last 3 years?'
    },
    priorPolicyInformation: {
        id: 'quoteandbind.ho.policy-info.Prior Policy Information',
        defaultMessage: 'Prior Policy Information'
    },
    termType: {
        id: 'quoteandbind.ho.policy-info.Term Type',
        defaultMessage: 'Term Type'
    },
    expirationDate: {
        id: 'quoteandbind.ho.policy-info.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    priorCarrierName: {
        id: 'quoteandbind.ho.policy-info.Prior Carrier Name',
        defaultMessage: 'Prior Carrier Name'
    },
    priorPolicy: {
        id: 'quoteandbind.ho.policy-info.Prior Policy #',
        defaultMessage: 'Prior Policy #'
    },
    priorExpirationDate: {
        id: 'quoteandbind.ho.policy-info.Prior Expiration Date',
        defaultMessage: 'Prior Expiration Date'
    },
    numberOfPriorInsurance: {
        id: 'quoteandbind.ho.policy-info.Number of Years Prior Insurance',
        defaultMessage: 'Number of Years Prior Insurance'
    }
});
